<section [ngClass]="{ admin: this.checkUserType('admin') }">
  <div class="floating-buttons">
    <!-- <button mat-fab color="primary" (click)="openRedeemCoupon()">
      <mat-icon>card_giftcard</mat-icon>
    </button> -->
    <button mat-fab color="primary" (click)="activeChatbot = true">
      <mat-icon>help</mat-icon>
    </button>
  </div>
  <div class="chatbot" [@activeChatbot]="activeChatbot ? 'open' : 'closed'">
    <div class="bot-action-buttons">
      <button mat-icon-button (click)="activeChatbot = false">
        <mat-icon>cancel</mat-icon>
      </button>
    </div>
    <iframe
      src="https://webchat.botframework.com/embed/jstorebot?s=dSvECEAx6Ac.Od_TMU652d3n7jyTp0sezd6_slJyiG_Uk1nJ9HlSDSM"
      style="width: 100%; height: 100%"
    ></iframe>
  </div>
  <jeanologia-layout
    #layout
    [buttonApps]="false"
    [logo]="this.logo"
    [show_flags]="true"
    [footerText]="footerText"
    [userInfoObservable]="this.userInfoSubject"
    [routes]="routes"
    (changeLanguage)="this.changeLanguage($event)"
    (clickOnSupport)="this.navigateToSupport()"
    (clickOnLogout)="this.logOutFromServer()"
  >
  </jeanologia-layout>
</section>